import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, type CanActivate, type GuardResult, RouterStateSnapshot} from '@angular/router';
import {InstanceUserRoleID, ResourceService} from '@middleware';
import {UserService} from '@services/user/user.service';
import {lastValueFrom} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ResourceEditorGuard implements CanActivate {
  constructor(
    private readonly resourceService: ResourceService,
    private readonly userService: UserService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GuardResult> {
    try {
      const resource = await lastValueFrom(this.resourceService.getResource(route.params['id']));
      const me = await this.userService.userPromise;
      if (!resource || !me) return false;
      if (resource.owners.map(owner => owner.email).includes(me.email)) return true;
      if (
        me.instance_user_role_id == InstanceUserRoleID.ADMIN &&
        me.organization.id == resource.creator?.organization?.id
      )
        return true;
      return false;
    } catch (_) {
      return false;
    }
  }
}
